function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#BBB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6F6F6F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EB3435"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B33"
})), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  id: "c",
  d: "M9.664 9.072h4.831l9.228 14.833h.062V9.072h4.552v22.111h-4.862L14.278 16.38h-.062v14.803H9.664z"
}), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: "137.5%",
  height: "131.7%",
  x: "-18.7%",
  y: "-11.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35.914,
  height: 40,
  x: 1.075,
  fill: "#333",
  rx: 3.441
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.301)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.871,
  cy: 1.075,
  r: 1.075,
  fill: "#111"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.871,
  cy: 21.29,
  r: 1.075,
  fill: "#111"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.871,
  cy: 11.183,
  r: 1.075,
  fill: "#111"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.871,
  cy: 31.398,
  r: 1.075,
  fill: "#111"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.301,
  height: 1.29,
  y: 0.43,
  fill: "url(#a)",
  rx: 0.645
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.301,
  height: 1.29,
  y: 20.43,
  fill: "url(#a)",
  rx: 0.645
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.301,
  height: 1.29,
  y: 10.538,
  fill: "url(#a)",
  rx: 0.645
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.301,
  height: 1.29,
  y: 30.538,
  fill: "url(#a)",
  rx: 0.645
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#d)",
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "nonzero",
  d: "M53.208 9.152H58.2l9.536 15.328h.064V9.152h4.704V32H67.48l-9.504-15.296h-.064V32h-4.704V9.152zm27.05 14.592c0 .661.065 1.307.193 1.936.128.63.346 1.195.656 1.696.309.501.72.901 1.232 1.2.512.299 1.152.448 1.92.448s1.413-.15 1.936-.448a3.454 3.454 0 0 0 1.248-1.2c.309-.501.528-1.067.656-1.696a9.929 9.929 0 0 0 0-3.888 4.98 4.98 0 0 0-.656-1.696c-.31-.49-.726-.89-1.248-1.2-.523-.31-1.168-.464-1.936-.464s-1.408.155-1.92.464c-.512.31-.923.71-1.232 1.2a4.98 4.98 0 0 0-.656 1.696 9.929 9.929 0 0 0-.192 1.952zm-4.543 0c0-1.323.202-2.523.608-3.6.405-1.077.981-1.995 1.728-2.752a7.743 7.743 0 0 1 2.688-1.76c1.045-.416 2.218-.624 3.52-.624 1.301 0 2.48.208 3.536.624 1.056.416 1.957 1.003 2.704 1.76.746.757 1.322 1.675 1.728 2.752.405 1.077.608 2.277.608 3.6s-.203 2.517-.608 3.584c-.406 1.067-.982 1.979-1.728 2.736a7.531 7.531 0 0 1-2.704 1.744c-1.056.405-2.235.608-3.536.608-1.302 0-2.475-.203-3.52-.608a7.56 7.56 0 0 1-2.688-1.744c-.747-.757-1.323-1.67-1.728-2.736-.406-1.067-.608-2.261-.608-3.584zm25.61-8.288h3.328v3.04h-3.328v8.192c0 .768.128 1.28.384 1.536s.768.384 1.536.384c.256 0 .502-.01.736-.032.235-.021.459-.053.672-.096V32c-.384.064-.81.107-1.28.128-.469.021-.928.032-1.376.032-.704 0-1.37-.048-2-.144a4.716 4.716 0 0 1-1.664-.56 2.965 2.965 0 0 1-1.136-1.184c-.277-.512-.416-1.184-.416-2.016v-9.76H94.03v-3.04h2.752v-4.96h4.544v4.96zm16.427 6.496c-.213-1.152-.592-2.027-1.136-2.624-.544-.597-1.37-.896-2.48-.896-.725 0-1.328.123-1.808.368s-.864.55-1.152.912a3.34 3.34 0 0 0-.608 1.152 5.216 5.216 0 0 0-.208 1.088h7.392zm-7.392 2.88c.064 1.472.437 2.539 1.12 3.2s1.664.992 2.944.992c.917 0 1.707-.23 2.368-.688.661-.459 1.067-.944 1.216-1.456h4c-.64 1.984-1.621 3.403-2.944 4.256-1.323.853-2.923 1.28-4.8 1.28-1.301 0-2.475-.208-3.52-.624-1.045-.416-1.93-1.008-2.656-1.776-.725-.768-1.285-1.685-1.68-2.752-.395-1.067-.592-2.24-.592-3.52 0-1.237.203-2.39.608-3.456a8.11 8.11 0 0 1 1.728-2.768 8.133 8.133 0 0 1 2.672-1.84c1.035-.448 2.181-.672 3.44-.672 1.408 0 2.635.272 3.68.816a7.344 7.344 0 0 1 2.576 2.192 9.007 9.007 0 0 1 1.456 3.136c.299 1.173.405 2.4.32 3.68H110.36zm19.37-11.936h-4.543V9.152h4.544v3.744zm-7.263 21.024c.234.085.554.128.96.128.469 0 .88-.09 1.232-.272.352-.181.528-.581.528-1.2v-17.12h4.544V32.8c0 .853-.091 1.59-.272 2.208a3.427 3.427 0 0 1-.928 1.552c-.438.416-1.03.725-1.776.928-.747.203-1.696.304-2.848.304a7.375 7.375 0 0 1-1.44-.128V33.92zm15.018-10.176c0 .661.064 1.307.192 1.936.128.63.347 1.195.656 1.696.31.501.72.901 1.232 1.2.512.299 1.152.448 1.92.448s1.414-.15 1.936-.448a3.454 3.454 0 0 0 1.248-1.2c.31-.501.528-1.067.656-1.696a9.929 9.929 0 0 0 0-3.888 4.98 4.98 0 0 0-.656-1.696c-.309-.49-.725-.89-1.248-1.2-.522-.31-1.168-.464-1.936-.464s-1.408.155-1.92.464c-.512.31-.922.71-1.232 1.2a4.98 4.98 0 0 0-.656 1.696 9.929 9.929 0 0 0-.192 1.952zm-4.544 0c0-1.323.203-2.523.608-3.6.406-1.077.982-1.995 1.728-2.752a7.743 7.743 0 0 1 2.688-1.76c1.046-.416 2.219-.624 3.52-.624 1.302 0 2.48.208 3.536.624 1.056.416 1.958 1.003 2.704 1.76.747.757 1.323 1.675 1.728 2.752.406 1.077.608 2.277.608 3.6s-.202 2.517-.608 3.584c-.405 1.067-.981 1.979-1.728 2.736a7.531 7.531 0 0 1-2.704 1.744c-1.056.405-2.234.608-3.536.608-1.301 0-2.474-.203-3.52-.608a7.56 7.56 0 0 1-2.688-1.744c-.746-.757-1.322-1.67-1.728-2.736-.405-1.067-.608-2.261-.608-3.584zm28.011 10.304c-.49 1.344-1.173 2.304-2.048 2.88-.875.576-2.09.864-3.648.864-.47 0-.933-.016-1.392-.048a66.49 66.49 0 0 1-1.392-.112v-3.744c.427.043.864.085 1.312.128.448.043.896.053 1.344.032.597-.064 1.04-.299 1.328-.704.288-.405.432-.853.432-1.344 0-.363-.064-.704-.192-1.024l-5.792-15.52h4.832l3.744 11.328h.064l3.616-11.328h4.704l-6.912 18.592z"
}));

var SvgNotejoy = function SvgNotejoy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 40,
    viewBox: "0 0 168 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotejoy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notejoy.d726099a.svg";
export { ForwardRef as ReactComponent };